<template>
  <div class="deliver-goods">
    <div class="table-wrapper">
      <div class="header">
          <el-form ref="form" :model="form" label-width="70px">
            <el-row :gutter="8">
              <el-col :span="6" v-if="activeSubTab === 1">
                <el-form-item label="订单号">
                  <el-input v-model="form.orderNum" placeholder="可输入主单号/子单号查询"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6" v-if="activeSubTab === 1">
                <el-form-item label="订单状态">
                  <el-select v-model="form.status" size="small" clearable placeholder="请选择">
                    <el-option
                      label="全部"
                      :value="0">
                    </el-option>
                    <el-option
                      label="已出库"
                      :value="1">
                    </el-option>
                    <el-option
                      label="已到分仓"
                      :value="2">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="出库日期">
                  <el-date-picker
                    v-model="form.date"
                    :clearable="false"
                    unlink-panels
                    type="daterange"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    range-separator="-"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    @change="handleRangePickerChange"
                    size="small">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6" v-if="activeSubTab === 2">
                <el-form-item label="商品编码">
                  <el-input v-model="form.ruigu_code" placeholder="请输入商品编码"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6" v-if="activeSubTab === 2">
                <el-form-item label="商品名称">
                  <el-input v-model="form.name" placeholder="请输入商品名称"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6" v-if="activeSubTab === 2">
                <el-form-item label="品牌">
                  <el-input v-model="form.b_name" placeholder="请输入品牌"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-button type="default" class="default-btn btn" @click="exportData">导出</el-button>
                <el-button type="primary" @click="onSubmit" class="btn">搜索</el-button>
                <el-button type="default" class="default-btn btn" @click="resetData">重置</el-button>
              </el-col>
            </el-row>
          </el-form>
      </div>
      <tabs :tabList="subTabList" :activeTab="activeSubTab" :changeTab="changeTab"/>
<!--      订单统计-->
      <div v-if="activeSubTab === 1">
        <el-table :data="tableData"
                  show-summary
                  :summary-method="getSummaries"
                  style="width: 100%"
                  :max-height="300"
                  :loading="loading">
          <el-table-column prop="serialNum" label="序号"></el-table-column>
          <el-table-column prop="created_at" label="订单推送日期"></el-table-column>
          <el-table-column prop="main_number" label="主单号"></el-table-column>
          <el-table-column prop="order_number" label="子单号"></el-table-column>
          <el-table-column prop="ruigu_code" label="商品编码"></el-table-column>
          <el-table-column prop="name" label="商品名称"></el-table-column>
          <el-table-column prop="send_amount" label="采购数量"></el-table-column>
          <el-table-column prop="price" label="采购单价"></el-table-column>
          <el-table-column prop="total_price" label="采购总金额"></el-table-column>
          <el-table-column prop="delivery_time" label="出库日期"></el-table-column>
          <el-table-column prop="mo_status" label="订单状态">
            <template slot-scope="scope">
              <span>{{scope.row.mo_status === 5 ? '已出库' : scope.row.mo_status === 6 ? '已到分仓' : ''}}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
<!--      商品统计-->
      <div v-if="activeSubTab === 2">
        <el-table :data="tableData"
                  show-summary
                  :summary-method="getSummaries"
                  style="width: 100%"
                  :max-height="300"
                  :loading="loading">
          <el-table-column prop="serialNum" label="序号"></el-table-column>
          <el-table-column prop="ruigu_code" label="商品编码"></el-table-column>
          <el-table-column prop="name" label="商品名称"></el-table-column>
          <el-table-column prop="b_name" label="品牌"></el-table-column>
          <el-table-column prop="unit" label="单位"></el-table-column>
          <el-table-column prop="price" label="采购单价"></el-table-column>
          <el-table-column prop="send_amount" label="采购数量"></el-table-column>
          <el-table-column prop="total_price" label="采购总金额"></el-table-column>
        </el-table>
      </div>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 50, 100, 200]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import Tabs from "@/components/tabs/tabs";
import {queryDeliverGoodsList} from "../../../../models/r4ReportModel";
import r4ReportApiList from "../../../../service/basic/r4ReportApiList";
import {buildURL} from "../../../../utils/utils";
import moment from "moment";
export default {
  components: {
    Tabs
  },
   data() {
     return {
       form: {
         date: [moment().subtract(7, 'days').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
         orderNum: '',
         ruigu_code: '',
         name: '',
         b_name: '',
         status: ''
       },
       pageSize: 10,
       page: 1,
       tableData: [],
       loading: false,
       activeSubTab: 1,
       subTabList: [
         {
           id: 1,
           name: '订单统计'
         },
         {
           id: 2,
           name: '商品统计'
         }
       ],
       totalCount:0,
       pickerOptions: {
         disabledDate (current) {
           return current && (current > moment().endOf('day') || current < moment().subtract(3, 'months'))
         }
       },
     }
   },
    mounted () {
      this.loadDeliverGoodsList(1);
    },
   methods: {
     // 获取发货列表
     loadDeliverGoodsList(tab) {
       this.activeSubTab = tab;
       queryDeliverGoodsList({
         shop_id: localStorage.getItem('shop_id'),
         number: this.form.orderNum,
         start_time: this.form.date ? this.form.date[0] + ' 00:00:00' : '',
         end_time: this.form.date ? this.form.date[1] + ' 23:59:59' : '',
         tab,
         status: this.form.status === 0 ? '' : this.form.status,
         is_export: 0,
         ruigu_code: this.form.ruigu_code,
         name: this.form.name,
         b_name: this.form.b_name,
         page: this.page,
         page_size: this.pageSize
       }).then(res => {
         this.tableData = res ? res.list ? res.list.map((item, index) => {
           item.serialNum = index + 1 + (this.page) * this.pageSize;
           return item;
         }) : [] : [];
         console.log(this.tableData, "tableData");
         this.totalCount = res ? res.total : 0;
       }).catch((err) => {
         console.log(err);
         this.$message.error(err.message);
       });
     },
     changeTab(type) {
       this.activeSubTab = type;
       this.form = {
         date: [moment().subtract(7, 'days').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
         orderNum: '',
         ruigu_code: '',
         name: '',
         b_name: '',
         status: ''
       }
       this.loadDeliverGoodsList(this.activeSubTab);
     },
     resetData() {
       this.form = {
         date: [moment().subtract(7, 'days').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
         orderNum: '',
         ruigu_code: '',
         name: '',
         b_name: '',
         status: ''
       }
       this.page = 1;
       this.pageSize = 10;
       this.loadDeliverGoodsList(this.activeSubTab);
     },
     handleRangePickerChange(value) {
       console.log(value, "value", moment(value[1]).subtract(3, "months").isBefore(moment(value[0])));
       if (!moment(value[1]).subtract(3, "months").isBefore(moment(value[0]))) {
         this.$message.error("选择的时间跨度最大为3个月");
         this.form.date = [moment(value[1]).subtract(3, "months").format('YYYY-MM-DD'), moment(value[1]).format('YYYY-MM-DD')];
       } else {
         this.form.date = value;
       }
     },
     onSubmit() {
        this.loadDeliverGoodsList(this.activeSubTab);
     },
     handleSizeChange (val) {
       this.pageSize = val
       this.loadDeliverGoodsList(this.activeSubTab);
     },
     handleCurrentChange (val) {
       this.page = val
       this.loadDeliverGoodsList(this.activeSubTab);
     },
     //导出
     exportData() {
       const params = {
         shop_id: localStorage.getItem('shop_id'),
         number: this.form.orderNum,
         start_time: this.form.date ? this.form.date[0] + ' 00:00:00' : '',
         end_time: this.form.date ? this.form.date[1] + ' 23:59:59' : '',
         tab: this.activeSubTab,
         status: this.form.status === 0 ? '' : this.form.status,
         is_export: 1,
         ruigu_code: this.form.ruigu_code,
         name: this.form.name,
         b_name: this.form.b_name,
       }
       console.log(params, "导出");
      window.open(`${echarthostname}${r4ReportApiList.getDeliverGoodsList}?${buildURL(params)}`);
     },
     getSummaries(param) {
       const { columns, data } = param;
       console.log(columns, data, "columns, data");
       const sums = [];
       columns.forEach((column, index) => {
         if (index === 0) {
           sums[index] = '总计';
           return;
         }
         const values = data.map(item => Number(item[column.property]));
         console.log(values, "values");
         console.log(column, "column");
         if ((!values.every(value => isNaN(value))) && (column.property === 'send_amount')) {
           sums[index] = Number(values.reduce((prev, curr) => {
             const value = Number(curr);
             if (!isNaN(value)) {
               return prev + curr;
             } else {
               return prev;
             }
           }, 0));
         } else if ((!values.every(value => isNaN(value))) && (column.property === 'total_price')) {
           sums[index] = Number(values.reduce((prev, curr) => {
             const value = Number(curr);
             if (!isNaN(value)) {
               return prev + curr;
             } else {
               return prev;
             }
           }, 0)).toFixed(2);
         } else {
           sums[index] = '';
         }
       });

       return sums;
     }
   }
}
</script>

<style lang="scss" scoped>
.deliver-goods {
  width: 100%;
  padding: 0 10px;
  background: #fff;
  margin-top: 10px;
  .btn {
    width: 70px;
    height: 30px;
    background: linear-gradient(132deg, #FF602F 0%, #FF3722 100%, #FF3621 100%, #FF3621 100%, #FF3722 100%);
    border-radius: 6px;
    font-size: 8px;
    font-family: MicrosoftYaHei;
    color: #FFFFFF;
    padding: 0;
    line-height: 30px;
    margin-top: 5px;
  }

  .default-btn {
    background: #fff;
    font-size: 8px;
    font-family: MicrosoftYaHei;
    color: #666666;
    border-radius: 6px;
    border: 1px solid #D5D5D5;
  }
  .el-input__inner {
    width: 100% !important;
  }
  .el-icon-date:before {
    position: absolute;
    top:0 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/r4SettlementReport/summaryReport/components/deliverGoodsList.vue